import {
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAIL,
  SAVE_PROFILE,
  FETCH_PROFILE,
  SAVE_PROFILE_SUCCESS,
  SAVE_PROFILE_FAIL,
} from "../actions/types";

const initialState = {
  loading: false,
  error: '',
  profile: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_PROFILE: {
      return {
        ...state,
        loading: true,
        error: '',
      };
    }
    case FETCH_PROFILE_SUCCESS: {
      return {
        ...state,
        loading: false,
        profile: action.payload,
      };
    }
    case FETCH_PROFILE_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case SAVE_PROFILE: {
      return {
        ...state,
        loading: true,
        error: '',
      };
    }
    case SAVE_PROFILE_SUCCESS: {
      return {
        ...state,
        loading: false,
        profile: action.payload,
      };
    }
    case SAVE_PROFILE_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    default:
      return state;
  }
}